import React from 'react';
import {BlockMath} from "react-katex";
import ReactHtmlParser from 'react-html-parser';

const ConvertToLatex = ({textInput}) => {
    const Entities = require('html-entities').AllHtmlEntities;
    const entities = new Entities();

    const textInputDecode = entities.decode(textInput);
    const lengthText = textInputDecode.length;
    const startLatex = textInputDecode.search("<latex>");
    const endLatex = textInputDecode.search("</latex>");
    const textBeforeLatex = textInputDecode.slice(0, startLatex);
    const textAfterLatex = textInputDecode.slice(endLatex, lengthText);
    const latex = textInputDecode.slice(startLatex, endLatex).replace("<latex>", "").replace("</latex>", "");
    return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            {ReactHtmlParser(textBeforeLatex)}
            <BlockMath>{latex}</BlockMath>
            {ReactHtmlParser(textAfterLatex)}
        </div>
    )
};

export default ConvertToLatex;
